import React from "react";
import CustomerFinancial from "../customers/customerFinancial";

const AllPreFinancing = () => {
  return <CustomerFinancial scope="global" />;
};

export default AllPreFinancing;
